
import { Component, Vue } from 'vue-property-decorator';
import * as THREE from 'three';
import VantaFog from 'vanta/dist/vanta.fog.min';
import * as Tone from 'tone'; // @ is an alias to /src
import '@fontsource/condiment';

const VANTA_CONFIG_BASE = {
    mouseControls: false,
    touchControls: false,
    gyroControls: false,
    // minHeight: 200.00,
    // minWidth: 200.00,
    blurFactor: 0.5,
    speed: 1.0,
    zoom: 1.2,
    baseColor: 0xffffff,
};

const VANTA_CONFIG_RARITY: {
    key: string,
    highlightColor: number,
    midtoneColor: number,
    lowlightColor: number,
}[] = [{
    key: 'SS',
    highlightColor: 0xffff00,
    midtoneColor: 0xf5e400,
    lowlightColor: 0xaa5010,
}, {
    key: 'S',
    highlightColor: 0xf0f0ff,
    midtoneColor: 0xc0c0d0,
    lowlightColor: 0x9999aa,
}, {
    key: 'A',
    highlightColor: 0xff8855,
    midtoneColor: 0xeeaa33,
    lowlightColor: 0x995522,
}];

@Component
export default class extends Vue {
    vantaEffect: any = null;

    ready: string = 'not-ready';

    get gift() {
        if (typeof this.$route.query.gift !== 'string') {
            return '';
        }
        return this.$route.query.gift;
    }

    get rarity() {
        if (typeof this.$route.query.rarity !== 'string') {
            return '';
        }
        if (!(VANTA_CONFIG_RARITY.map(config => config.key)).includes(this.$route.query.rarity)) {
            return '';
        }
        return this.$route.query.rarity;
    }


    get rarityConfig() {
        return VANTA_CONFIG_RARITY.find(config => config.key === this.rarity) || {};
    }

    mounted() {
    }

    effect() {
        this.vantaEffect = VantaFog({
            ...VANTA_CONFIG_BASE,
            ...this.rarityConfig,
            ...{
                el: this.$el,
                THREE: THREE,
            },
        });
    }

    boot() {
        this.ready = 'ready';
        this.effect();
        this.playSound();
    }

    beforeDestroy() {
        if (this.vantaEffect != null) {
            this.vantaEffect.destroy();
        }
    }

    playSound() {
        Tone.Transport.stop();
        Tone.Transport.cancel();
        Tone.Transport.bpm.value = 240;
        const poly = new Tone.PolySynth().toDestination();
        const partB = new Tone.Part(function(time){
            poly.triggerAttackRelease(["C4", "E4", "G4", "A#5" ], "2n", time);
        }, [
            { time: '0:0.0' },
        ]).start(3.4);
        Tone.Transport.start();
    }
}
